import React from 'react';
import { Col, Row, Container } from 'reactstrap';
import BreadCrumb from '../../../components/common/BreadCrumb';
import { useMediaQuery } from 'react-responsive';
import TotalDeviceAndScoreTable from '../vskor/TotalDeviceAndScoreTable';
import SdkVersionDistribution from '../vskor/SdkVersionDistribution';
import TotalDistribution from '../vskor/TotalDistribution';
import Widget from '../vskor/Widget';
import UpgradeAccountNotice from '../vskor/UpgradeAccountNotice';
import ConfidenceLevelChart from '../vskor/ConfidenceLevelChart';
import CreditUsageGraphic from '../vskor/CreditUsageGraphic';

// Fake Data
import TotalDeviceAndScoreData from '../vskor/fakedata/total_device_and_score.json';


const AImeeAnalytics = () => {
    const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });

    const currentMonth = 'February';
    const previousMonth = 'January';

    const calculatePercentageChange = (current, previous) => {
        if (previous === 0) return 0;
        return ((current - previous) / previous) * 100;
    };

    const currentData = TotalDeviceAndScoreData.months[currentMonth];
    const previousData = TotalDeviceAndScoreData.months[previousMonth];

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="AImee Analytics" pageTitle="AImee" />
                <Row>
                    <Col xxl={6} md={6} className="d-flex flex-column">
                        <Row>
                            <Col md={12}>
                                <UpgradeAccountNotice />
                            </Col>
                        </Row>
                        <Row className="flex-grow-1">
                            <Col md={6}>
                                <Widget
                                    title="Total Users"
                                    value={currentData.totalDevice / 1000}
                                    valueSuffix="k"
                                    percentage={calculatePercentageChange(currentData.totalDevice, previousData.totalDevice).toFixed(2)}
                                    percentageType={calculatePercentageChange(currentData.totalDevice, previousData.totalDevice) >= 0 ? 'success' : 'danger'}
                                    icon="users"
                                />
                            </Col>


                        </Row>
                        <Row className="mt-1 flex-grow-1">
                            <Col md={6}>
                                <Widget
                                    title="Total Android Users"
                                    value={currentData.android / 1000}
                                    valueSuffix="k"
                                    percentage={calculatePercentageChange(currentData.android, previousData.android).toFixed(2)}
                                    percentageType={calculatePercentageChange(currentData.android, previousData.android) >= 0 ? 'success' : 'danger'}
                                    icon="android"
                                />
                            </Col>
                            <Col md={6}>
                                <Widget
                                    title="Total iOS Users"
                                    value={currentData.ios / 1000}
                                    valueSuffix="k"
                                    percentage={calculatePercentageChange(currentData.ios, previousData.ios).toFixed(2)}
                                    percentageType={calculatePercentageChange(currentData.ios, previousData.ios) >= 0 ? 'success' : 'danger'}
                                    icon="apple"
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={6} >
                        <SdkVersionDistribution />
                    </Col>

                </Row>

            </Container>
        </div>
    );
};

export default AImeeAnalytics;
